import { getReq } from './axios';
import { allBalanceParams } from './models';
var BASE_URL = "".concat(apiUrl, "/balance");
export var getAvailableFunds = function getAvailableFunds(params) {
  return getReq("".concat(BASE_URL, "/available-funds"), {
    params: allBalanceParams(params)
  });
};